import { difference, find, get, lowerCase } from 'lodash'
import {
  type FilterValues,
  type FilterConfiguration,
  GA4_FILTER_TYPES,
  type GoogleAnalyticsContextInterface,
} from 'providers/googleAnalytics/types'
import { mapDataToFilterEvent } from '../helpers'

interface Props
  extends Pick<GoogleAnalyticsContextInterface, 'executeDataToDataLayer'> {
  isEnabled: boolean
  newValues: FilterValues['categories']
  previousValues: FilterValues['categories']
  options: FilterConfiguration['viewComponentProps']['options']
}

export const executeCategoryFilterEvent = ({
  isEnabled,
  newValues,
  previousValues,
  options,
  executeDataToDataLayer,
}: Props) => {
  if (!isEnabled) {
    return
  }

  const updatedDataValues = difference(newValues, previousValues)

  if (!updatedDataValues.length) {
    return
  }

  const updatedDataLabels = updatedDataValues.map((value): string =>
    get(
      find(options, {
        value,
      }),
      'label'
    )
  )

  updatedDataLabels.forEach((updatedLabel) => {
    executeDataToDataLayer(
      mapDataToFilterEvent({
        type: GA4_FILTER_TYPES.CATEGORIES,
        action: lowerCase(updatedLabel),
      })
    )
  })
}
